// extracted by mini-css-extract-plugin
export default {"messageViewerContainer":"_message-viewer_messageViewerContainer__O89DU"};